import _implicitStylesheets from "./toast.css";
import _implicitScopedStylesheets from "./toast.scoped.css?scoped=true";
import _adsIcon from "ads/icon";
import _aceLink from "ace/link";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="title${0}" type-style="body-3"${2}>${"t1"}</div>`;
const $fragment2 = parseFragment`<a${"a0:href"}${3}>${"t1"}</a>`;
const stc0 = {
  "toast": true
};
const stc1 = {
  classMap: {
    "icon_container": true
  },
  key: 1
};
const stc2 = {
  props: {
    "symbol": "warning",
    "spriteSheet": "symbols",
    "size": "large",
    "fill": "#FE9339"
  },
  key: 2
};
const stc3 = {
  classMap: {
    "content_container": true
  },
  key: 3
};
const stc4 = {
  classMap: {
    "text": true
  },
  attrs: {
    "type-style": "body-3"
  },
  key: 6
};
const stc5 = {
  key: 7
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {k: api_key, c: api_custom_element, h: api_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, t: api_text, i: api_iterator} = $api;
  return api_iterator($cmp.props.toasts, function (toast) {
    return api_element("div", {
      classMap: stc0,
      key: api_key(0, toast.id)
    }, [api_element("div", stc1, [api_custom_element("ads-icon", _adsIcon, stc2)]), api_element("div", stc3, [api_static_fragment($fragment1, 5, [api_static_part(1, null, api_dynamic_text(toast.title))]), api_element("div", stc4, [api_text(api_dynamic_text(toast.text)), api_custom_element("ace-link", _aceLink, stc5, [api_static_fragment($fragment2, 9, [api_static_part(0, {
      attrs: {
        "href": toast.link_url
      }
    }, null), api_static_part(1, null, api_dynamic_text(toast.link_text))])])])])]);
  });
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-4vaoo6b42dq";
tmpl.legacyStylesheetToken = "undefined-_toast";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
